<template>
  <TheCatcherComponent>
    <StepSwap :category :is-focused :model :price :without-left-template />
  </TheCatcherComponent>
</template>

<script setup lang="ts">
import type { Price } from '@backmarket/http-api/src/api-models/Price'

import TheCatcherComponent from '~/scopes/buyback/components/BuybackErrorBoundary/BuybackErrorBoundary.vue'
import StepSwap from '~/scopes/buyback/swap/components/SwapStep/SwapStep.vue'

defineProps<{
  isFocused: boolean
  price?: Price
  model?: string
  category?: string
  withoutLeftTemplate?: boolean
}>()
</script>
